module.exports = __webpack_public_path__ + "img/h_s1e2_gallery_1.8dd1481b.png";